import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { IncidentModel, IncidentNoteModel, IncidentStatus } from '@models';
import { Store } from '@ngrx/store';
import { IncidentsActions } from '@ngrx-store';
import { IncidentsService } from '@services';
import { NotificationsService } from '@ui';

import { IncidentNoteComponent } from './incident-note.component';

@Component({
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatProgressSpinner, IncidentNoteComponent],
  selector: 'avs-incident-notes',
  styleUrl: './incident-notes.component.scss',
  templateUrl: './incident-notes.component.html',
})
export class IncidentNotesComponent implements OnInit {
  incident = input.required<IncidentModel>();
  noteAdded = output<IncidentNoteModel>();
  protected postNoteLoading = signal(false);
  protected noteDescription = '';
  protected eIncidentStatus = IncidentStatus;
  protected notes = signal<IncidentNoteModel[]>([]);

  private notificationService = inject(NotificationsService);
  private incidentService = inject(IncidentsService);
  private store = inject(Store);

  ngOnInit() {
    this.incidentService
      .getIncidentNotes(this.incident().id)
      .subscribe(notes => {
        this.notes.set(notes);
      });
  }

  protected addNote() {
    this.postNoteLoading.set(true);
    this.incidentService
      .addIncidentNote(this.incident().id, { textValue: this.noteDescription })
      .subscribe({
        complete: () => {
          this.postNoteLoading.set(false);
        },
        error: error => {
          this.notificationService.showErrorMessage(error.message);
        },
        next: note => {
          this.noteDescription = '';
          this.notes.update(notes => [note, ...notes]);
          this.store.dispatch(IncidentsActions.loadAllIncidents());
          this.noteAdded.emit(note);
        },
      });
  }
}
